import { useCallback, useState } from "react";

/**
 * Controls when a field's inline error is shown: reveal on blur,
 * hide again while the user edits.
 *
 * Validity can still be computed continuously (e.g. RHF `mode: "all"`);
 * this only gates display of the error UI.
 */
export function useBlurFieldErrorVisibility(): {
  showError: boolean;
  revealError: () => void;
  hideError: () => void;
} {
  const [showError, setShowError] = useState(false);

  const revealError = useCallback(() => {
    setShowError(true);
  }, []);

  const hideError = useCallback(() => {
    setShowError(false);
  }, []);

  return { showError, revealError, hideError };
}
